import SearchContext from 'contexts/SearchContext';
import React, { useContext } from 'react';

import SingleSelect from '../inputs/SingleSelect';
import { setPage, setSort, setSortDirection } from 'contexts/SearchActions';
import { Mixpanel } from 'utils/Mixpanel';
import SortDirectionButton from 'components/search/SortDirectionButton';

function SearchSort() {
    const { state, dispatch } = useContext(SearchContext);
    const sortOptions = state.availableSorts
        ? state.availableSorts.map((s) => ({
              label: s.name,
              value: s.slug
          }))
        : [];

    const handleSortChange = (sort) => {
        setPage(dispatch, 1);
        setSort(dispatch, sort);
        Mixpanel.track('Search sort change', {
            sort: sort?.value
        });
    };

    const handleSortDirectionChange = (direction) => {
        setPage(dispatch, 1);
        setSortDirection(dispatch, direction);
        Mixpanel.track('Search sort change', {
            direction
        });
    };

    return (
        <div className="flex items-center relative z-10 gap-1">
            <div className="min-w-[180px]">
                <SingleSelect
                    value={sortOptions.find((so) => so.value === state.sort?.value) || ''}
                    name="sort"
                    placeholder="Razvrsti"
                    options={sortOptions}
                    onChange={handleSortChange}
                    isClearable
                />
            </div>

            {state.sort?.value && state.sort.value !== 'nearby' && (
                <SortDirectionButton onChange={handleSortDirectionChange} value={state.sortDirection} />
            )}
        </div>
    );
}

export default SearchSort;
